import { createResourceModule } from '../../../lib/resource/module.js';
import { propertyGroupDetail } from './schemas.js';

export const propertyGroups = createResourceModule({
  resource: 'propertyGroups',
  basePath: '/v1/property-groups',
  detail: propertyGroupDetail,
});

export const propertyGroupEndpoints = propertyGroups.endpoints;
